import { crudRequest } from '@/services/api';

const state = {}
for (let dsIndex = 0; dsIndex < 2; dsIndex++) {
  state[`arrived${dsIndex}`] = {}
}

export default {
  namespace: 'arrived',
  state: { ...state },

  effects: {
    *arrived({ payload: { data, dsIndex } }, { call, put, select }) {
      yield put({ type: 'updateState', payload: { [`arrived${dsIndex}`]: data[0].result } })
    }
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}